import React from "react";
import styled from "styled-components";
import { StaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import { Section, Container } from "@components/global";

const About = () => (
  <StaticQuery
    query={graphql`
      query {
        datoCmsAbout {
          blurbOneNode {
            childMarkdownRemark {
              html
            }
          }
          blurbThreeNode {
            childMarkdownRemark {
              html
            }
          }
          blurbTwoNode {
            childMarkdownRemark {
              html
            }
          }
          headerOne
          headerTwo
          headerThree
          imageOne {
            fluid(maxWidth: 760) {
              ...GatsbyDatoCmsFluid_tracedSVG
            }
          }
          imageTwo {
            fluid(maxWidth: 760) {
              ...GatsbyDatoCmsFluid_tracedSVG
            }
          }
          imageThree {
            fluid(maxWidth: 760) {
              ...GatsbyDatoCmsFluid_tracedSVG
            }
          }
        }
      }
    `}
    render={(data) => (
      <Section id="about" accent>
        <Container>
          <Grid>
            <div>
              <h2>{data.datoCmsAbout.headerOne}</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    data.datoCmsAbout.blurbOneNode.childMarkdownRemark.html,
                }}
              ></div>
            </div>
            <Art>
              <Img fluid={data.datoCmsAbout.imageOne.fluid} />
            </Art>
          </Grid>
          <Grid inverse>
            <Art>
              <Img fluid={data.datoCmsAbout.imageTwo.fluid} />
            </Art>
            <div>
              <h2>{data.datoCmsAbout.headerTwo}</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    data.datoCmsAbout.blurbTwoNode.childMarkdownRemark.html,
                }}
              ></div>
            </div>
          </Grid>
          <Grid>
            <div>
              <h2>{data.datoCmsAbout.headerThree}</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    data.datoCmsAbout.blurbThreeNode.childMarkdownRemark.html,
                }}
              ></div>
            </div>
            <Art>
              <Img fluid={data.datoCmsAbout.imageThree.fluid} />
            </Art>
          </Grid>
        </Container>
      </Section>
    )}
  />
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-gap: 40px;
  text-align: right;
  align-items: center;
  justify-items: center;
  margin: 24px 0;

  ${(props) =>
    props.inverse &&
    `
    text-align: left;
    grid-template-columns: 2fr 3fr;
  `}

  h2 {
    margin-bottom: 16px;
  }

  @media (max-width: ${(props) => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    text-align: left;
    margin-bottom: 96px;

    &:last-child {
      margin-bottom: 24px;
    }

    ${(props) =>
      props.inverse &&
      `
        ${Art} {
          order: 2;
        }
    `}
  }
`;

const Art = styled.figure`
  margin: 0;
  max-width: 380px;
  width: 100%;
`;

export default About;
